module.exports = "<footer class=\"footer is-transparent\">\r\n    <div class=\"container\">\r\n      <div class=\"content has-text-centered\">\r\n        <a class=\"footer-item\" href=\"mailto:support@book-it.today\" target=\"_blank\">\r\n          <span class=\"icon is-size-3\">\r\n            <fa name=\"question-circle\"></fa>\r\n          </span>\r\n        </a>\r\n      </div>\r\n    </div>\r\n</footer>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-general/components/footer/footer.component.html
// module id = ./src/app/ui-general/components/footer/footer.component.html
// module chunks = main